export type Sponsor = {
	id: string
	header: string
	subHeader: string
	companyName: string
	sponsorName: string
	website: string
	phone: string
	email: string
	content: string
	footer: string
	imgSrc: string
	description: string
}

export const SPONSORS = [
	{
		id: 'sagility',
		header: 'Anand Natampalli',
		subHeader: 'Tech Enabled Healthcare BPM',
		companyName: 'Sagility',
		sponsorName: 'Anand Natampalli',
		website: 'https://www.sagilityhealth.com',
		phone: '+1-201-286-7717',
		email: 'anandmn@sagilityhealth.com',
		content: 'Content',
		footer: 'Footer',
		imgSrc: '/img/sponsors/anand_natampalli.png',
		features: [],
		description:
			'Sagility is a U.S.-based, tech-enabled healthcare business process management company that supports payers, providers, and their partners to deliver best-in-class operations, enhance the member and provider experience, improve the quality of care and promote health equity all while delivering cost effective healthcare financial and clinical outcomes.',
	},
	{
		id: 'rci',
		header: 'Ankeit Ghai',
		subHeader: 'Real Estate Property Mgmt.',
		companyName: 'RCI Realty',
		sponsorName: 'Ankeit Ghai',
		website: 'https://www.rcirealtyllc.com',
		phone: '+1-847-404-5699',
		email: 'ankeit@rcirealtyllc.com',
		content: 'Content',
		footer: 'Footer',
		imgSrc: '/img/sponsors/ankeit_ghai.png',
		features: [],
		description:
			'RCI Property Management is a full-service property management brokerage with a proven ability to create and operate thriving rental apartment communities. Our team provides the expertise of management needed to effectively lease multi-family, condo and single-family properties in Illinois.\n We enhance an asset’s long-term value through quality preventative maintenance, strategic capital improvements, exceptional customer service, and thoughtful management of every dollar to your bottom line.',
	},
	{
		id: 'first',
		header: 'Rahul Bhatia',
		subHeader: 'India Focused Hedge Fund',
		companyName: 'First Principles Funds',
		sponsorName: 'Rahul Bhatia',
		website: 'https://www.firstprinciplesfunds.com',
		phone: '+1-214-668-9666',
		email: 'corporate@firstprinciplesfunds.com',
		content: 'Content',
		footer: 'Footer',
		imgSrc: '/img/sponsors/rahul_bhatia.avif',
		features: [],
		description:
			'The fund invests in a select few high-quality, attractively valued Indian companies.\nDesigned for Qualified US based investors looking to participate in India’s long-term growth in a convenient, transparent manner.\nManaged by ex-Warburg Pincus and ex-Citi investment professionals with over 30 years of combined investing experience.',
	},
	{
		id: 'swg',
		header: 'Sanjay Wagle',
		subHeader: 'Wealth Management',
		companyName: 'Strategic Wealth Group',
		sponsorName: 'Sanjay Wagle',
		website: 'https://www.swgadvisors.com',
		phone: '+1-630-469-0100',
		email: 'swagle@swgadvisors.com',
		content: 'Content',
		footer: 'Footer',
		imgSrc: '/img/sponsors/sanjay_wagle.jpg',
		description: null,
		features: [
			'Independent boutique Financial Planning and Wealth Management Firm with a focus on good folks who care about hands-on, personal attention.',
			'Individualized planning strategies for tax efficient wealth accumulation, decumulation and preservation.',
			'Tax efficient, actively managed portfolios that blend fundamental research and technical analysis.',
			'White glove experience that builds deep and meaningful client partnerships.',
			'If you fail to plan, you are planning to fail - Benjamin Franklin',
		],
	},
	{
		id: 'abs',
		header: 'Snehal Patel',
		subHeader: 'Mortgage Agent',
		companyName: 'ABS Funding',
		sponsorName: 'Snehal Patel',
		website: 'https://www.absmtg.com',
		phone: '+1-847-942-2393',
		email: 'spatel@absmtg.com',
		content: 'Content',
		footer: 'Footer',
		imgSrc: '/img/sponsors/snehal.png',
		features: [],
		description:
			'Strong reputation as an outstanding mortgage brokerage firm Serving the lending needs of real estate professionals, builders, and individual home buyers throughout Illinois. Full-service mortgage brokerage with an experienced staff offering expertise in every area of mortgage lending from purchase to refinance to construction lending. Access to a full range of mortgage products dedicated to finding the right loan-with the best rates, terms and costs-to meet vour unique needs.',
	},
	{
		id: 'omega',
		header: 'Sumit Sachdeva',
		subHeader: 'Healthcare RCM Company',
		companyName: 'Omega',
		sponsorName: 'Sumit Sachdeva',
		website: 'https://www.omegahms.com',
		phone: '+1-630-889-9629',
		email: 'sumit.sachdeva@omegahms.com',
		content: 'Content',
		footer: 'Footer',
		imgSrc: '/img/sponsors/sumit_sachdeva.png',
		features: [],
		description:
			'Omega Healthcare is a trusted partner that helps improve financial outcomes through technology and clinically enabled transformational solutions for healthcare and life sciences organizations.\nOmega Healthcare’s flexible portfolio of platform-based services is tailored to the unique needs of its clients. Solutions encompass point solutions and fully managed services and help increase revenues, decrease costs, and improve the overall patient-provider-payer experience.',
	},
	{
		id: 'mpc',
		header: 'Mitul Patel',
		subHeader: 'Product Development Consulting',
		companyName: 'MP Consulting',
		sponsorName: 'Mitul Patel',
		website: 'https://mpconsulting.com',
		phone: '+1-224-656-4071',
		email: 'mitul@mpconsulting.com',
		content: 'Content',
		footer: 'Footer',
		imgSrc: '/img/sponsors/mitul-patel.jpeg',
		features: [],
		description:
			'MP Consulting, LLC (MPC) is a dynamic product development firm with a team of over 100 highly skilled engineers and professionals dedicated to bringing connectivity solutions to a wide array of products across consumer, industrial, medical, and automotive verticals. With primary offices in Palatine, IL and Ahmedabad, India, MPC has swiftly established itself as a leader in product development and engineering services, leveraging a multidisciplinary approach to deliver innovative and high-quality solutions.',
	},
	{
		id: 'bbq',
		header: 'Absolute BBQ',
		subHeader: 'Authentic Indian Cuisine',
		companyName: 'Absolute BBQ',
		sponsorName: 'Absolute BBQ',
		website: 'https://absolutebbqusa.com',
		phone: '+1-630-420-7777',
		email: 'absolutebbqil@gmail.com',
		content: 'Content',
		footer: 'Footer',
		imgSrc: '/img/sponsors/absolute_bbq.png',
		features: [],
		description:
			'Absolute BBQ Authentic Indian Cuisine in Naperville IL offers an array of traditional Indian dishes known for vibrant spices and authentic flavors. The restaurant specializes in catering services, tailoring menus to fit different occasions, from intimate gatherings to large events. Their offerings feature fresh, seasonal ingredients, with customizable options to meet diverse dietary needs. The team ensures a seamless, high-quality experience, whether providing a classic three-course meal or interactive food stations.',
	},
]
